import { HttpEventType } from '@angular/common/http';
import { Component, OnInit, Optional } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom, Subscription } from 'rxjs';
import { PriceListEnums } from 'src/app/enum/price-list-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PriceListImportModel } from 'src/app/models/imports/price-list-import.model';
import { PriceListDetailService } from 'src/app/services/archive/price-list-detail.service';
import { PriceListService } from 'src/app/services/archive/price-list.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-price-list',
  templateUrl: './import-price-list.component.html',
  styleUrls: ['./import-price-list.component.scss'],
  standalone: false
})
export class ImportPriceListComponent implements OnInit {

  eventFile: any;
  errorPriceList: number = 0;
  formImport: FormGroup = new FormGroup({});
  listTypeImport: CustomListDropdown[] = [
    { label: 'Valores', value: 1 },
    { label: 'Porcentajes', value: 2 }
  ];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = 'Ningún archivo seleccionado.';
  priceListAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  priceListDetailImport: boolean = false;
  priceListId: number = 0;
  priceListCode: number = 0;
  suscription: Subscription;
  typeSelected: string = "value";
  visibleTxt: boolean = false;

  constructor(public config: DynamicDialogConfig,
    private priceListDetailService: PriceListDetailService,
    private priceListService: PriceListService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) { }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.priceListId = inputs.priceListId;
      this.priceListCode = inputs.priceListCode;
    });
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.priceListDetailImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  changeTypeSelected(type: number) {
    if (type === 1) {
      this.typeSelected = "value";
    } else {
      this.typeSelected = "percentage";
    }
  }

  downloadGuideImport() {
    this.priceListService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaListaPrecios.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.priceListAlerts || this.priceListAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.priceListDetailService.exportImportErrors(this.priceListAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionListaPrecios_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  handleImportResponse(response: LoadPreInvoicingModel) {
    this.loadPreInvoicingModel = response;
    this.priceListAlerts = response?.alerts ?? [];
    this.errorPriceList = response?.preInvoicingStateId;

    if (this.errorPriceList === 1) {
      this.errorPriceList = 1;
      this.visibleTxt = true;
      this.toastHandlerService.showToast(
        'error',
        'La importación terminó con errores, puede exportarlos si lo desea.',
        'ERROR'
      );
    } else if (this.priceListAlerts.length > 0) {
      this.visibleTxt = true;
      this.toastHandlerService.showToast(
        'error',
        'La importación terminó con alertas, puede exportarlas si lo desea'
      );
    } else {
      this.visibleTxt = false;
      this.priceListDetailImport = true;
      this.toastHandlerService.showToast(
        'success',
        'La importación terminó exitosamente.'
      );
      this.close();
    }
    this.clearInputFile();
  }

  importPriceList() {
    this.priceListAlerts = [];
    this.errorPriceList = 0;
    this.visibleTxt = false;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<PriceListImportModel>();
    let row: PriceListImportModel;
    let numberList: number, articleCode: number, articleName: string, unitValue: number,
      rateDiscount: number, counter: number = 1, swManual: boolean;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }

      rows.splice(0, 1);
      if (this.typeSelected == "value") {
        rows.forEach(element => {
          counter = counter + 1;
          let rowHasError = false;

          //A. Número lista
          numberList = parseFloat(element[0] as string);
          if (isNaN(numberList)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter + 1}. Columna A. El número de la lista no es válido.`;
            this.priceListAlerts.push(alert);
            rowHasError = true;
          }

          //B. Código Artículo:
          articleCode = parseFloat(element[1] as string);
          if (isNaN(articleCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter + 1}. Columna B. El código del artículo no es válido.`;
            this.priceListAlerts.push(alert);
            rowHasError = true;
          }

          //C. Nombre Artículo
          articleName = element[2] as string;
          if (articleName == null) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}. Columna C. El nombre del artículo no es válido.`;
            this.priceListAlerts.push(alert);
            rowHasError = true;
          } else if (articleName.length > 150) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}. Columna C. El nombre del artículo supera el tamaño máximo de caracteres (150).`;
            this.priceListAlerts.push(alert);
            rowHasError = true;
          }

          //D. Porcentaje Descuento:
          unitValue = parseFloat(element[3] as string);
          if (isNaN(unitValue) || unitValue < 0) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter + 1}. Columna D. El vr. unitario del artículo no es válido.`;
            this.priceListAlerts.push(alert);
            rowHasError = true;
          }

          //E. SwManual:
          if (element[4] as string != "S" && element[4] as string != "N") {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Columna E, Fila ${counter}. El Manual debe ser valores como: S / N.`;
            this.priceListAlerts.push(alert);
            rowHasError = true;
          }
          swManual = element[4] as string === "S";

          if (!rowHasError) {
            row = new PriceListImportModel(counter, this.priceListId, numberList, articleCode,
              articleName, unitValue, 0, swManual);
            rowsImports.push(row);
          } else {
            isOk = false;
          }
        });

        if (!isOk || rowsImports.length === 0) {
          this.errorPriceList = 1;
          this.visibleTxt = true;
          this.toastHandlerService.showToast(
            'error',
            'La importación terminó con errores, puede exportarlos si lo desea.',
            'ERROR'
          );
          return;
        }

        if (this.priceListCode == PriceListEnums.base) {
          await this.importValuesPriceListBase(rowsImports);
        } else {
          await this.importValuesPriceList(rowsImports);
        }

      } else {
        //No permito importar porcentajes si es la lista base:
        if (this.priceListCode == PriceListEnums.base) {
          this.toastHandlerService.showToast(
            'error',
            'La lista base solo admite importacion de valores.'
          );
        } else {
          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;
            //A. Número lista
            numberList = parseFloat(element[0] as string);
            if (isNaN(numberList)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. Columna A. El número de la lista no es válido.`;
              this.priceListAlerts.push(alert);
              rowHasError = true;
            }

            //B. Código Artículo
            articleCode = parseFloat(element[1] as string);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. Columna B. El código del artículo no es válido.`;
              this.priceListAlerts.push(alert);
              rowHasError = true;
            }

            //C. Nombre Artículo:
            articleName = element[2] as string;
            if (articleName == null) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. Columna C. El nombre del artículo no es válido.`;
              this.priceListAlerts.push(alert);
              rowHasError = true;
            } else if (articleName.length > 150) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. Columna C. El nombre del artículo supera el tamaño máximo de caracteres (150).`;
              this.priceListAlerts.push(alert);
              rowHasError = true;
            }

            //D. Porcentaje Descuento:
            rateDiscount = parseFloat(element[3] as string);
            if (isNaN(rateDiscount)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter + 1}. Columna D. El campo Tarifa Descuento no es válido.`;
              this.priceListAlerts.push(alert);
              rowHasError = true;
            }
            if (rateDiscount < -9999 || rateDiscount > 100) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter + 1}. Columna D. El campo Tarifa Descuento debe ser un valor entre -9999.99999 y 100.`;
              this.priceListAlerts.push(alert);
              rowHasError = true;
            }

            if (!rowHasError) {
              row = new PriceListImportModel(counter, this.priceListId, numberList, articleCode, articleName, 0, rateDiscount);
              rowsImports.push(row);
            }
          });

          if (!isOk || rowsImports.length === 0) {
            this.errorPriceList = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea.',
              'ERROR'
            );
            return;
          }

          await this.importPercentagePriceList(rowsImports);
        }
      }
    });
  }

  async importPercentagePriceList(rowsImports: Array<PriceListImportModel>) {
    try {
      this.handleImportResponse(
        await firstValueFrom(this.priceListDetailService.importPercentagePriceList(rowsImports))
      );
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Porcentajes.', error);
    }
  }

  async importValuesPriceListBase(rowsImports: Array<PriceListImportModel>) {
    try {
      this.handleImportResponse(
        await firstValueFrom(this.priceListDetailService.importValuesPriceListBase(rowsImports))
      );
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Valores a la Lista de Precios Base.', error);
    }
  }

  async importValuesPriceList(rowsImports: Array<PriceListImportModel>) {
    try {
      this.handleImportResponse(
        await firstValueFrom(this.priceListDetailService.importValuesPriceList(rowsImports))
      );
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Valores a la Lista de Precios.', error);
    }
  }
}
